// extracted by mini-css-extract-plugin
export default {"container":"sections_container__WU4k0","section":"sections_section__LmCH7","row":"sections_row__azwhh","column1":"sections_column1__cvGrn","column2":"sections_column2__85MUc"};